import {createFormHook} from '@tanstack/react-form'

import {setInitialFieldValues} from './initial-values.js'
import {CheckBox} from '../../components/form/checkbox.js'
import {CheckboxCard} from '../../components/form/checkbox-card.js'
import {Combobox} from '../../components/form/combobox.js'
import {ComboboxInfinite} from '../../components/form/combobox-infinite.js'
import {DatePicker} from '../../components/form/date-picker.js'
import {ErrorObserver} from '../../components/form/error-observer.js'
import {HourInput} from '../../components/form/hour-input.js'
import {InfiniteCombobox} from '../../components/form/infinite-combobox.js'
import {InfiniteSelect} from '../../components/form/infinite-select.js'
import {NextStepButton} from '../../components/form/next-step-button.js'
import {NumberInput} from '../../components/form/number-input.js'
import {PasswordField} from '../../components/form/password-field.js'
import {PhoneField} from '../../components/form/phone-field.js'
import {RadioCard} from '../../components/form/radio-card.js'
import {Searchbox} from '../../components/form/searchbox.js'
import {Select} from '../../components/form/select.js'
import {SubmitButton} from '../../components/form/submit-button.js'
import {Switch} from '../../components/form/switch.js'
import {Slider} from '../../components/form/slider.js'
import {TabsField} from '../../components/form/tabs-field.js'
import {TabUnsavedIndicator} from '../../components/form/tab-unsaved-indicator.js'
import {TextField} from '../../components/form/text-field.js'
import {Textarea} from '../../components/form/textarea.js'
import {createFormHookContexts} from '@tanstack/react-form'
import {CreatableCombobox} from '../../components/form/creatable-combobox.js'

const {fieldContext, useFieldContext, formContext, useFormContext} = createFormHookContexts()

const {useAppForm, withForm, withFieldGroup} = createFormHook({
  fieldComponents: {
    TextField,
    PasswordField,
    Select,
    InfiniteSelect,
    Switch,
    Searchbox,
    CheckBox,
    CheckboxCard,
    Textarea,
    DatePicker,
    NumberInput,
    HourInput,
    Combobox,
    ComboboxInfinite,
    InfiniteCombobox,
    CreatableCombobox,
    PhoneField,
    TabsField,
    Slider,
    RadioCard,
  },
  formComponents: {
    SubmitButton,
    ErrorObserver,
    NextStepButton,
    TabUnsavedIndicator,
  },
  fieldContext,
  formContext,
})

function getFirstInvalidField() {
  return document.querySelector('[aria-invalid="true"]') as HTMLInputElement
}

function focusFirstErrorField() {
  const invalidInput = getFirstInvalidField()

  invalidInput?.focus()
}

export {
  getFirstInvalidField,
  focusFirstErrorField,
  setInitialFieldValues,
  useAppForm,
  useFieldContext,
  useFormContext,
  withFieldGroup,
  withForm,
}

export type UseAppFormReturn = ReturnType<typeof useAppForm>
